import React, { useState, useEffect } from 'react';
import Button from '../ui/Button';
import Input from '../ui/Input';
import Icon from '../AppIcon';
import api from 'utils/api';
import { toast } from 'react-hot-toast';

const SendPaymentModal = ({ isOpen, onClose, booking, onSuccess }) => {
  const [amount, setAmount] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);

  // استخراج هوشمند اطلاعات (پشتیبانی از دیتای قدیمی و جدید)
  const clientName = booking?.clientName || booking?.client?.name || 'مشتری';
  const clientPhone = booking?.clientPhone || booking?.client?.phoneNumber;
  const serviceName = booking?.service?.name || 'خدمت';
  const bookingId = booking?._id;
  useEffect(() => {
    if (booking?.service?.price) {
      setAmount(booking.service.price);
    }
    setDescription(`هزینه سرویس ${serviceName}`);
  }, [booking]);

  const handleSend = async () => {
    console.log('🚀 دکمه ارسال کلیک شد'); // لاگ ۱

    if (!amount) {
      alert('لطفا مبلغ را وارد کنید'); // استفاده از alert برای اطمینان (چون شاید toast زیر مودال بماند)
      return;
    }

    if (!bookingId) {
      console.error('❌ خطا: شناسه رزرو (Booking ID) وجود ندارد!', booking);
      alert('خطای سیستمی: شناسه رزرو یافت نشد.');
      return;
    }

    setLoading(true);
    const toastId = toast.loading('در حال ارسال...');

    try {
      console.log(
        `📤 Sending Request to: /bookings/${bookingId}/send-payment-link`
      );
      console.log('📦 Payload:', { amount, description });

      const response = await api.post(
        `/bookings/${bookingId}/send-payment-link`,
        {
          amount: Number(amount),
          description,
        }
      );

      console.log('✅ Response:', response.data);

      toast.success('لینک ارسال شد', { id: toastId });

      if (onSuccess) onSuccess();
      onClose();
    } catch (error) {
      console.error('❌ API Error:', error);

      // نمایش خطا با Alert محض اطمینان
      const errorMsg =
        error.response?.data?.message || 'خطا در برقراری ارتباط با سرور';
      alert(`خطا: ${errorMsg}`);

      toast.error(errorMsg, { id: toastId });
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    // ✅ Z-Index 60: برای اینکه روی مودال تاریخچه (که معمولا 50 است) بیفتد
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[60] flex items-center justify-center p-4">
      <div className="bg-white w-full max-w-md rounded-lg shadow-2xl animate-scale-in border border-gray-200">
        <div className="flex items-center justify-between p-4 border-b border-gray-100">
          <h3 className="text-lg font-bold flex items-center gap-2 text-gray-800">
            <Icon name="CreditCard" className="text-[#01B5AD]" />
            ارسال لینک پرداخت
          </h3>
          <Button variant="ghost" size="icon" onClick={onClose} iconName="X" />
        </div>

        <div className="p-6 space-y-4">
          <div className="bg-blue-50 text-blue-700 p-3 rounded-lg text-sm flex gap-2 border border-blue-100">
            <Icon name="Info" size={18} className="shrink-0 mt-0.5" />
            <p>
              یک پیامک حاوی لینک پرداخت برای <strong>{clientName}</strong> ارسال
              می‌شود و وضعیت نوبت به "منتظر پرداخت" تغییر می‌کند.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-4 text-sm text-gray-500 mb-2">
            <div>
              موبایل:{' '}
              <span className="text-gray-800 dir-ltr font-mono">
                {clientPhone}
              </span>
            </div>
            <div>
              سرویس: <span className="text-gray-800">{serviceName}</span>
            </div>
          </div>

          <Input
            label="مبلغ نهایی (تومان)"
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="مثلا: 500000"
            className="text-left dir-ltr"
            required
          />

          <Input
            label="توضیحات (اختیاری)"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="توضیحات تکمیلی برای مشتری..."
          />
        </div>

        <div className="p-4 border-t border-gray-100 flex justify-end gap-2 bg-gray-50 rounded-b-lg">
          <Button variant="outline" onClick={onClose} disabled={loading}>
            انصراف
          </Button>
          <Button
            variant="default"
            onClick={handleSend}
            loading={loading}
            iconName="Send"
            iconPosition="right">
            ارسال پیامک
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SendPaymentModal;
